import React, { useContext } from 'react';
import { Row, Image, Col } from '@thd-olt-component-react/core-ui';
import { DataContext } from '../../contexts';
import { getImageURL, getHostCURL } from '../../common/utils/cardUtils';
import './WelcomeCardHeader.scss';

export const WelcomeCardHeader = () => {
  const year = new Date().getFullYear();
  const { userData, isAdmin } = useContext(DataContext);
  const proTiers = userData && userData.proTiers;
  const currentTierName = proTiers?.currentTierName || 'MEMBER';
  let tierImage;
  if (currentTierName === 'MEMBER') {
    tierImage = 'ProTiers/tier-badge-MEMBER.svg';
  } else if (currentTierName === 'VIP') {
    tierImage = 'ProTiers/tier-badge-VIP.svg';
  } else if (currentTierName === 'Elite') {
    tierImage = 'ProTiers/tier-badge-ELITE.svg';
  } else {
    tierImage = 'ProTiers/tier-badge-MEMBER.svg';
  }
  return (
    <Row>
      <a
        href={isAdmin && getHostCURL('/myaccount/proxtraprogramdetails')}
        rel=" noreferrer"
        className="header-container"
      >
        <div className="header-badge">
          <Image
            className="header-badge-image"
            src={getImageURL(tierImage)}
            alt="header-icon"
            height="auto"
            width="auto"
          />
          <div className={`member-background member-background-color-${currentTierName}`}>
            <div>
              <Image
                src={getImageURL('ProTiers/Pro-Xtra-logo-text.svg')}
                alt="logo-text"
                height="12"
                width="57"
                className="proxtraLogo"
              />
            </div>
            <div className="badge-text-tier">
              {currentTierName.toUpperCase()}
            </div>
            {isAdmin && (
              <div>
                <Image
                  src={getImageURL('ProTiers/caret-white.svg')}
                  alt=">"
                  width="auto"
                  height="13px"
                  className="proxtraLogo"
                />
              </div>
            )}
          </div>
        </div>
      </a>
    </Row>
  );
};
